export default {"src":"/_next/static/media/alert_triangle.ee68a844.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};